<template>
  <v-content class="pa-0">
    <Loader class="loader-statistics" v-if="loading"></Loader>
    <div v-else>
      <v-toolbar color="white" class="elevation-0">
        <v-toolbar-title>
          <h3>{{chart_name}}</h3>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-flex sm4 md3 class="statistics-desktop">
          <osobasearch :spolupracovnik="true" label="Vyhledat osobu" class="mt-3" v-model="osoba_id"></osobasearch>
        </v-flex>
      </v-toolbar>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="1200px"
        transition="dialog-transition"
        v-if="dialog"
        @keydown.esc="dialog=false"
      >
        <v-card class="no__padding">
          <v-card-title class="pa-0">
            <v-layout row wrap align-center>
              <v-flex grow>
                <h2>{{chart_name}}</h2>
              </v-flex>
              <v-flex shrink>
                <v-btn class="ma-0" color="grey lighten-3 elevation-0" fab icon small @click="dialog=false"><v-icon>close</v-icon></v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-0 mt-3" style="overflow: hidden;">
            <v-layout row wrap>
              <v-flex shrink>
                <v-btn-toggle class="ma-0" v-model="chart_tab">
                  <v-btn class="stats-btn" dark :value="0">Vše</v-btn>
                  <v-btn class="stats-btn" dark :value="1">Posledních 12 měsíců</v-btn>
                  <v-btn class="stats-btn" dark :value="2">Předchozích 12 měsíců</v-btn>
                  <v-btn class="stats-btn" dark :value="3">Tento rok</v-btn>
                  <v-btn class="stats-btn" dark :value="4">minulý rok</v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
            <apexchart width="100%" height="480" type="bar" :options="options" :series="series"></apexchart>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div class="statistics desktop">
        <v-layout row wrap class="elevation-2">
          <v-flex sm5 md4 lg3>
            <div class="pa-2 border-right">
              <div class="pr-2 left-aside" ref="left">
                <v-layout row wrap align-center :class="{ 'grey lighten-4 border-box': i % 2 == 0 }" class="left-aside__item border-box" v-for="(n, i) in items">
                  <v-flex sm7 class="pa-2">
                    <p class="mb-0">{{n.nazev_osoby}}</p>
                  </v-flex>
                  <v-flex sm5 class="border-left">
                    <v-layout column wrap>
                      <v-flex xs12 class="pa-7 border-bottom">
                        <strong>Osobní</strong>
                      </v-flex>
                      <v-flex xs12 class="pa-7 d-flex align-center" style="min-height: 40px">
                        <v-btn v-if="n.podrizeni" :to="{ path: '/statistiky/' + tab + '/' + id + '?osoba=' + n.id }" target="_blank" dark depressed small class="ma-0 text-none bold" style="margin-top:-3px!important" color="green accent-4">Skupinové</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-flex>

          <v-flex sm5 md6 lg7>
            <div class="statistics-wrap">
              <div class="statistics-header" ref="header">
                <v-layout row>
                  <v-flex class="statistics-col pa-2" v-for="n in dates">
                    <div>{{n.dateInt | formatDateMonth}}</div>
                  </v-flex>
                </v-layout>
              </div>
              <div class="statistics-content" ref="body">
                <div v-for="(item, i) in items">
                  <v-layout row>
                    <v-flex class="statistics-col" v-for="n in item.data">
                      <div class="text-xs-right pa-2" :class="{ 'grey lighten-4': i % 2 == 0 }">
                        <span v-if="n.type=='credit'"><span v-if="n.vlastni>0" class="bold">{{n.vlastni | formatMoney}} kr.</span><span v-else>--</span></span>
                        <span v-else-if="n.type=='int'"><span v-if="n.vlastni>0" class="bold">{{n.vlastni | formatInt}}</span><span v-else>--</span></span>
                        <span v-else-if="n.type=='double'"><span v-if="n.vlastni>0" class="bold">{{n.vlastni | formatDouble}}</span><span v-else>--</span></span>
                        <span v-else-if="n.type=='gram'"><span v-if="n.vlastni>0" class="bold">{{n.vlastni | formatMoney}} gr.</span><span v-else>--</span></span>
                        <span v-else-if="n.type=='money'"><span v-if="n.vlastni>0" class="bold">{{n.vlastni | formatMoney}} Kč</span><span v-else>--</span></span>
                        <span v-else><span v-if="n.vlastni>0" class="bold">{{n.vlastni | formatInt}}</span><span v-else>--</span></span>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex class="statistics-col" v-for="n in item.data">
                      <div class="text-xs-right pa-2" :class="{ 'grey lighten-4': i % 2 == 0 }">
                        <span v-if="n.type=='credit'"><span v-if="n.skupinove>0" class="bold">{{n.skupinove | formatMoney}} kr.</span><span v-else>--</span></span>
                        <span v-else-if="n.type=='int'"><span v-if="n.skupinove>0" class="bold">{{n.skupinove | formatInt}}</span><span v-else>--</span></span>
                        <span v-else-if="n.type=='double'"><span v-if="n.skupinove>0" class="bold">{{n.skupinove | formatDouble}}</span><span v-else>--</span></span>
                        <span v-else-if="n.type=='gram'"><span v-if="n.skupinove>0" class="bold">{{n.skupinove | formatMoney}} gr.</span><span v-else>--</span></span>
                        <span v-else-if="n.type=='money'"><span v-if="n.skupinove>0" class="bold">{{n.skupinove | formatMoney}} Kč</span><span v-else>--</span></span>
                        <span v-else><span v-if="n.skupinove>0" class="bold">{{n.skupinove | formatInt}}</span><span v-else>--</span></span>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </div>
          </v-flex>

          <v-flex sm2>
            <div class="left-aside btn-aside border-left" ref="right">
              <div class="pa-2 text-xs-center" v-for="(item, i) in items">
                <v-btn depressed color="primary" class="mx-0 mb-0 bold text-none" @click="showChart(item, 'osobni')"><v-icon class="mr-2">bar_chart</v-icon><span v-if="$vuetify.breakpoint.lgAndUp"> Osobní</span></v-btn>
                <v-btn depressed color="green accent-4" dark class="mx-0 mb-0 bold text-none" @click="showChart(item, 'skupinove')"><v-icon class="mr-2">bar_chart</v-icon><span v-if="$vuetify.breakpoint.lgAndUp"> Skupinové</span></v-btn>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div class="statistics-mobile">

        <v-flex xs12>
          <v-card color="white" class="mx-2 my-2 statistics-no__radius">
            <osobasearch :hideDetails="true" :spolupracovnik="true" label="Vyhledat osobu" class="pt-3 pb-2" v-model="osoba_id"></osobasearch>
          </v-card>
        </v-flex>

        <v-card color="grey lighten-3" class="mx-2 my-2 statistics-no__radius">
          <v-card-text class="text-xs-center pa-0 pt-1">
            <h3 class="pa-2 black--text">{{sm_date}}</h3>
          </v-card-text>
        </v-card>

        <div v-for="n in sm_items" class="pb-2">
          <v-card class="mx-2 statistics-no__radius">
            <v-card-text class="text-xs-center pa-0">
              <h3 class="mb-0 pa-2">{{n.nazev_osoby}}</h3>
              <v-layout row wrap class="border-top">
                <v-flex xs6 class="pa-2">
                  <strong>Osobní</strong>
                </v-flex>
                <v-flex xs6 class="pa-2 border-left">
                  <v-btn v-if="n.podrizeni" :to="{ path: '/statistiky/' + tab + '/' + id + '?osoba=' + n.id }" target="_blank" dark depressed small class="ma-0 text-none bold" style="margin-top:-3px!important" color="green accent-4">Skupinové</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <!-- <div v-for="(item, i) in items"> -->
          <div class="mx-2">
            <v-layout row>
              <!-- <v-flex class="statistics-col" v-for="n in item.data"> -->
              <v-flex class="statistics-col">
                <div class="pa-2">
                  <span v-if="n.data.type=='credit'"><span v-if="n.data.vlastni>0" class="bold">{{n.data.vlastni | formatMoney}} kr.</span><span v-else>--</span></span>
                  <span v-else-if="n.data.type=='int'"><span v-if="n.data.vlastni>0" class="bold">{{n.data.vlastni | formatInt}}</span><span v-else>--</span></span>
                  <span v-else-if="n.data.type=='double'"><span v-if="n.data.vlastni>0" class="bold">{{n.data.vlastni | formatDouble}}</span><span v-else>--</span></span>
                  <span v-else-if="n.data.type=='gram'"><span v-if="n.data.vlastni>0" class="bold">{{n.data.vlastni | formatMoney}} gr.</span><span v-else>--</span></span>
                  <span v-else-if="n.data.type=='money'"><span v-if="n.data.vlastni>0" class="bold">{{n.data.vlastni | formatMoney}} Kč</span><span v-else>--</span></span>
                  <span v-else><span v-if="n.data.vlastni>0" class="bold">{{n.data.vlastni | formatInt}}</span><span v-else>--</span></span>
                </div>
              </v-flex>
              <v-flex class="statistics-col">
                <div class="pa-2">
                  <span v-if="n.data.type=='credit'"><span v-if="n.data.skupinove>0" class="">{{n.data.skupinove | formatMoney}} kr.</span><span v-else>--</span></span>
                  <span v-else-if="n.data.type=='int'"><span v-if="n.data.skupinove>0" class="">{{n.data.skupinove | formatInt}}</span><span v-else>--</span></span>
                  <span v-else-if="n.data.type=='double'"><span v-if="n.data.skupinove>0" class="">{{n.data.skupinove | formatDouble}}</span><span v-else>--</span></span>
                  <span v-else-if="n.data.type=='gram'"><span v-if="n.data.skupinove>0" class="">{{n.data.skupinove | formatMoney}} gr.</span><span v-else>--</span></span>
                  <span v-else-if="n.data.type=='money'"><span v-if="n.data.skupinove>0" class="">{{n.data.skupinove | formatMoney}} Kč</span><span v-else>--</span></span>
                  <span v-else><span v-if="n.data.skupinove>0" class="">{{n.data.skupinove | formatInt}}</span><span v-else>--</span></span>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </div>
  </v-content>
</template>

<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        loadingTable: false,
        counter: 0,
        dates: [],
        items: [],
        init_done: false,
        osoba_id: null,
        dialog: false,
        options: {
          chart: {
            id: 'vuechart-example'
          },
          xaxis: {
            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
          }
        },
        series: [{
          name: 'series-1',
          data: [30, 40, 45, 50, 49, 60, 70, 91]
        }],
        chart_name: null,
        chart_id: null,
        sm_date: null,
        sm_items: [],
        min_date: null,
        max_date: null,
        min_date: null,
        max_date: null,
        chart_tab: 0,
        chart_type: null
      };
    },
    props: {
      id: String,
      tab: String
    },
    watch: {
      osoba_id (v) {
        this.setQuery("osoba", v);
        this.load();
      },
      dialog (v) {
        this.setQuery("graf", v ? this.chart_id : null);
        if (!v) {
          this.setQuery("gl", null);
          this.setQuery("gt", null);
        }
      },
      chart_tab (v) {
        this.showChart(this.chart_data, this.chart_type);
        this.setQuery("gl", v);
      }
    },
    mounted () {
      this.osoba_id = this.getQueryInt("osoba");
      this.load();
    },
    methods: {
      load: function() {
        this.loading = true;
        this.counter++;
        this.loadingTable = true;
        window.API.post("statistiky/" + this.tab + "/" + this.id, {
          echo: this.counter,
          osoba: this.osoba_id
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.dates = body.dates;
          this.items = body.data;
          this.min_date = new Date(body.min_date * 1000);
          this.max_date = new Date(body.max_date * 1000);
          this.loading = false;
          this.loadingTable = false;
          this.chart_name = body.name;
          if (this.getQuery("graf") != null && this.items.filterOne((e) => { return chart_id = e.id; }) != null) {
            var chart_id = this.getQuery("graf");
            this.chart_type = this.getQuery("gt");
            var gl = this.getQuery("gl");
            if (gl != null && !isNaN(gl) && parseInt(gl) >= 0 && parseInt(gl) <= 4)
              this.chart_tab = parseInt(gl);
            this.showChart(this.items.filterOne((e) => { return chart_id = e.id; }), this.getQuery("gt"))
          }
          if (this.items.length > 0) {
            this.sm_items = window.th.copy(this.items).map((e) => {
              e.data = e.data[e.data.length - 1];
              return e;
            });
            this.sm_date = moment(new Date(this.sm_items[0].data.cas * 1000)).format('MMMM YYYY').substr(0, 1).toUpperCase() + moment(new Date(this.sm_items[0].data.cas * 1000)).format('MMMM YYYY').substr(1);
          }
          this.$nextTick(() => {
            this.initScroll();
          });
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      initScroll () {
        this.$refs.left.addEventListener("scroll", () => {
          this.$refs.body.scrollTo(this.$refs.body.scrollLeft, this.$refs.left.scrollTop);
          this.$refs.right.scrollTo(this.$refs.right.scrollLeft, this.$refs.left.scrollTop);
        });
        this.$refs.body.addEventListener("scroll", () => {
          this.$refs.left.scrollTo(this.$refs.left.scrollLeft, this.$refs.body.scrollTop);
          this.$refs.right.scrollTo(this.$refs.right.scrollLeft, this.$refs.body.scrollTop);
        });
        this.$refs.right.addEventListener("scroll", () => {
          this.$refs.body.scrollTo(this.$refs.body.scrollLeft, this.$refs.right.scrollTop);
          this.$refs.left.scrollTo(this.$refs.left.scrollLeft, this.$refs.right.scrollTop);
        });
        this.$refs.body.addEventListener("scroll", () => {
          this.$refs.header.scrollTo(this.$refs.body.scrollLeft, this.$refs.body.scrollTop);
        });
        this.$refs.header.addEventListener("scroll", () => {
          this.$refs.body.scrollTo(this.$refs.header.scrollLeft, this.$refs.header.scrollTop);
        });
        this.$refs.body.scrollTo(this.$refs.body.scrollWidth - this.$refs.body.clientWidth, 0);
      },
      showChart (d, t) {
        if (t == null)
          t = "osobni";
        this.chart_data = d;
        this.chart_id = d.id;
        this.chart_type = t;
        this.setQuery("gt", t);
        this.options = {
          xaxis: {
            type: 'datetime',
            tickAmount: 6,
            labels: {
              formatter: function (value) {
                return moment(new Date(value)).format('MMMM YYYY').substr(0, 1).toUpperCase() + moment(new Date(value)).format('MMMM YYYY').substr(1);
              }
            }
          },
          tooltip: {
            x: {
              formatter: function (value) {
                return moment(new Date(value)).format('MMMM YYYY').substr(0, 1).toUpperCase() + moment(new Date(value)).format('MMMM YYYY').substr(1);
              }
            }
          },
          dataLabels: {
              enabled: false,
          },
          colors: [ t == "osobni" ? "#1976d2" : "#00c853" ],
          yaxis: t == 'osobni' ?
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#1976d2'
              },
              labels: {
                style: {
                  color: '#1976d2',
                }
              },
              title: {
                text: d.name + " (vlastní)",
                style: {
                  color: '#1976d2',
                }
              },
              tooltip: {
                enabled: true
              }
            } :
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#00c853'
              },
              labels: {
                style: {
                  color: '#00c853',
                }
              },
              title: {
                text: d.name + " (skupinové)",
                style: {
                  color: '#00c853',
                }
              },
              tooltip: {
                enabled: true
              }
            }
        };
        var min_date = 0;
        var max_date = 2147483647;
        if (this.chart_tab == 1) {
          min_date = parseInt(moment().subtract(12, 'months')._d.getTime() / 1000);
          max_date = parseInt(moment()._d.getTime() / 1000);
        }
        else if (this.chart_tab == 2) {
          min_date = parseInt(moment().subtract(24, 'months')._d.getTime() / 1000);
          max_date = parseInt(moment().subtract(12, 'months')._d.getTime() / 1000);
        }
        else if (this.chart_tab == 3) {
          min_date = parseInt(moment().startOf('year')._d.getTime() / 1000);
          max_date = parseInt(moment()._d.getTime() / 1000);
        }
        else if (this.chart_tab == 4) {
          min_date = parseInt(moment().subtract(1, 'years').startOf('year')._d.getTime() / 1000);
          max_date = parseInt(moment().subtract(1, 'years').endOf('year')._d.getTime() / 1000);
        }
        if (t == "osobni") {
          this.series = [
            {
              name: d.nazev_osoby + " (vlastní)",
              color: "#1976d2",
              data: d.data.filter((e) => { return e.cas >= min_date && e.cas <= max_date; }).map((e) => {
                return [ e.cas * 1000, e.vlastni ];
              })
            }
          ];
        }
        else {
          this.series = [
            {
              name: d.nazev_osoby + " (skupinové)",
              color: "#00c853",
              data: d.data.filter((e) => { return e.cas >= min_date && e.cas <= max_date; }).map((e) => {
                return [ e.cas * 1000, e.skupinove ];
              })
            }
          ];
        }
        this.dialog = true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Statistiky/SkupinoveStatistiky.vue